import { HttpErrorResponse, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  BadRequestHandler,
  GlobalMessageType,
  HttpResponseStatus,
} from '@spartacus/core'

@Injectable({
  providedIn: 'root',
})
export class MbBadRequestHandler extends BadRequestHandler {
  responseStatus = HttpResponseStatus.BAD_REQUEST

  handleError (request: HttpRequest<any>, response: HttpErrorResponse): void {
    this.handleBadPassword(request, response)
    this.handleBadLoginResponse(request, response)
    this.handleValidationError(request, response)
    this.handleGuestDuplicateEmail(request, response)
    this.handleMaxUploadSizeExceededError(request, response)
  }

  protected handleValidationError (request: HttpRequest<any>, response: HttpErrorResponse) {
    this.getErrors(response)
      .filter((e) => e.type === 'ValidationError')
      .forEach((error) => {
        if (request?.url?.includes('pageType=ProductPage') && error?.reason === 'invalid' && error?.subject === 'code') {
          return
        }

        this.globalMessageService.add(
          {
            key: `httpHandlers.validationErrors.${error.reason}.${error.subject}`,
          },
          GlobalMessageType.MSG_TYPE_ERROR
        )
      })
  }

  protected handleMaxUploadSizeExceededError (request: HttpRequest<any>, response: HttpErrorResponse) {
    this.getErrors(response)
      .filter((e) => e.type === 'MaxUploadSizeExceededError')
      .forEach((error) => {
        this.globalMessageService.add(
          {
            key: 'formValidationErrors.maxUploadSizeExceeded',
          },
          GlobalMessageType.MSG_TYPE_ERROR
        )
      })
  }
}
